import { Component, Prop, h, Element, Listen } from '@stencil/core';
import { PageNode } from 'interfaces/PageNode';


@Component({
    tag: 'app-util-nav',
    styleUrl: 'app-util-nav.scss',
    shadow: false,
})
export class AppUtility {
    @Element() root: HTMLElement;
    @Prop() utilityNodes: string = '';

    pageNodeArray: Array<PageNode> = [];

    componentWillLoad() {
        if (this.utilityNodes !== '') {
            this.pageNodeArray = JSON.parse(this.utilityNodes.trim().replace('},]', '}]'));
        }
    }

    @Listen('searchOpen', { target: 'window' })
    handleSearchOpen(event: CustomEvent<boolean>) {

        if (window.innerWidth >= 1199.98 && event.detail) {
            this.root.querySelector('.util-nav-items').classList.add('d-none');
        } else if (window.innerWidth >= 1199.98) {
            // setTimeout(() => {
            this.root.querySelector('.util-nav-items').classList.remove('d-none');
            // }, 350);
        }
    }


    render() {
        return (
            <div class="util-nav-list">
                <div class="container">
                    <div class="util-nav-items">
                        {this.pageNodeArray.map((node) => (
                            <a
                                class="util-nav-link"
                                href={node.UrlName}>
                                {node.Title}
                            </a>
                        ))}
                        <div class="search-wrapper">
                            <app-search search-id="desktopSearchInput" label="Search site" placeholder="Search our site..."></app-search>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
